import { gql } from "@apollo/client";

export const GET_MINUTA_DOCUMENTOS = gql`
    query GetDocumentoMinuta {
    documentoMinuta {
        idDocMinuta,
        descripcion,
        habilitado
    }
}
`;

export const GET_DOCUMENTOS_FAC = gql`
    query documentoFac{
        documentoFac {
            idDocumentoFac,
            nombre
    }
}
`;

export const adaptMinutaDocumento = (documento) => {
  return {
    idDocMinuta: documento?.idDocMinuta,
    descripcion: documento?.descripcion,
    habilitado: documento?.habilitado
  };
};

export const adaptMinutaDocumentoArray = (documentos) => {
    return structuredClone(documentos)
        ?.map(documento => adaptMinutaDocumento(documento));
}

export const adaptDocumentoFac = (documento) => {
    return {
        idDocMinuta: documento?.idDocumentoFac,
        descripcion: documento?.nombre,
    }
}

export const adaptDocumentoFacArray = (documentos) => {
    return structuredClone(documentos)
        ?.map(documento => adaptDocumentoFac(documento));
}